export const GET_CONFERENCES = 'GET_CONFERENCES';
export const ADD_CONFERENCE = 'ADD_CONFERENCE';
export const STOP_ADDING_CONFERENCE = 'STOP_ADDING_CONFERENCE';
